// Import: Middleware Action & Custom Types
import { CLEAN_REGISTERED_STORES, CLEAN_REGISTERED_STORES_ERROR } from '_models/redux/types';

// Action function
export const cleanIsRegisteredStores = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_REGISTERED_STORES,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_REGISTERED_STORES_ERROR,
      payload: undefined,
    });
  }
};
